import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { guidToBase64, base64ToGuid } from '../utils/guid-encode';
import { Injectable } from '@angular/core';

export const base64UrlSegmentParse = (url: string) => {
  const base64Regex = /([A-Za-z0-9-_]{22})==/g;
  return url.replace(base64Regex, (match) => base64ToGuid(match));
};

export const base64UrlSegmentEncode = (url: string) => {
  const guidRegex =
    /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/gi;
  return url.replace(guidRegex, (match) => `${guidToBase64(match)}==`);
};

@Injectable()
export class GuidUrlSerializer
  extends DefaultUrlSerializer
  implements UrlSerializer
{
  parse(url: string): UrlTree {
    // Convert base64url encoded GUIDs in the URL to their standard format
    url = base64UrlSegmentParse(url);

    // Call the parse method of the base class to parse the URL
    return super.parse(url);
  }

  serialize(tree: UrlTree): string {
    // Call the serialize method of the base class to serialize the URL
    let url = super.serialize(tree);

    // Convert GUIDs in the URL to their base64 encoded format
    url = base64UrlSegmentEncode(url);

    return url;
  }
}
